import React from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { kbCategories, kbArticles } from '../data/kbArticles';

const KnowledgeBase = () => {
  const grouped = kbCategories.map((category) => ({
    category,
    articles: kbArticles.filter((a) => a.category === category),
  }));

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Knowledge Base | Skillmeter</title>
        <meta name="description" content="Help articles and guides for using Skillmeter, the online skills testing platform." />
      </Helmet>

      <Header />

      <section className="py-12 bg-gray-50 sm:py-16 lg:py-20">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl">
              Knowledge Base
            </h1>
            <p className="mt-6 text-base font-normal text-gray-600">
              Guides and answers to help you get the most out of Skillmeter.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 mt-12 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8 lg:mt-16">
            {grouped.map(({ category, articles }) => (
              <div key={category} className="p-6 bg-white rounded-lg shadow-sm sm:p-8">
                <h2 className="text-xl font-bold text-gray-900">{category}</h2>
                <ul className="mt-5 space-y-3">
                  {articles.map((article) => (
                    <li key={article.slug}>
                      <Link
                        to={`/kb/${article.slug}`}
                        className="text-base font-medium text-smcolor hover:text-smcolor-dark"
                      >
                        {article.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <p className="mt-16 text-base font-normal text-center text-gray-600">
            Still need help? Email us at{' '}
            <a href="mailto:support@skillmeter.com" className="font-medium text-smcolor hover:text-smcolor-dark">
              support@skillmeter.com
            </a>
            .
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default KnowledgeBase;
